<template>
  <div class="flex-c-side">
    <el-form
      class="el-forms h-300"
      :inline="true"
      label-position="top"
      :model="formData"
      :rules="rules"
      ref="form"
    >
      <el-form-item label="姓名" prop="realName">
        <el-input placeholder="请输入" v-model="formData.realName"></el-input
      ></el-form-item>
      <el-form-item label="手机号码" prop="phoneNum">
        <el-input placeholder="请输入" v-model="formData.phoneNum"></el-input
      ></el-form-item>
      <el-form-item class="last-form-item" label="身份证号码" prop="idCardNum">
        <el-input placeholder="请输入" v-model="formData.idCardNum"></el-input
      ></el-form-item>
    </el-form>
    <div class="align-c">
      <el-button class="submit-btn" @click="handleSubmit">确定</el-button>
      <el-button class="cancel-btn" @click="handleCancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  emits: ['close'],
  props: ['keeper', 'storeId'],
  data() {
    return {
      formData: {
        realName: '',
        phoneNum: '',
        idCardNum: ''
      },
      rules: {
        realName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phoneNum: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const val = value.trim();
              if (!val) {
                callback(new Error('请输入手机号码'))
              } else if (val.length !== 11) {
                callback(new Error('请输入正确的手机号码'))
              } else {
                callback()
              }
            }, trigger: 'blur'
          }
        ],
        idCardNum: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const val = value.trim();
              if (!val) {
                callback(new Error('请输入身份证号码'))
              } else if (val.length !== 18) {
                callback(new Error('请输入正确的身份证号码'))
              } else {
                callback()
              }
            }, trigger: 'blur'
          }
        ]
      }
    }
  },
  created() {
    if (this.keeper) {
      this.formData = this.keeper;
    }
  },
  methods: {
    ...mapActions(["fetchData"]),

    // 提交
    handleSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.fetchData({
            url: 'USER.KEEPER_SAVE_OR_UPDATE',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            params: this.formData,
            flag: true
          }).then(res => {
            if (res && res.data && res.data.success) {
              if (this.keeper) {
                // 编辑操作不需要再重复绑定
                this.$message.success('操作成功')
                this.handleCancel(true)
              } else {
                this.boundKeeper(res?.data?.id)
              }
            } else {
              this.$message.error(res?.msg || '创建管家失败')
            }

          }).catch(() => {
            this.$message.error('创建管家失败')
          })
        }
      })
    },

    // 绑定管家
    boundKeeper(keeperId) {
      if (!keeperId || !this.storeId) return;
      this.fetchData({
        url: 'SHOP.KEEPER_BOUND',
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        params: { id: this.storeId, housekeeper: keeperId },
        flag: true,
      }).then(res => {
        if (res && res.data) {
          this.$message.success('操作成功')
          this.handleCancel(true)
        } else {
          this.$message.error(res?.msg || '操作失败')
        }

      }).catch(() => {
        this.$message.error('操作失败')
      })
    },

    // 关闭对话框
    handleCancel(success) {
      this.$emit('close', success)
    },

  }
}
</script>

<style lang="less" scoped>
.el-forms {
  justify-content: space-between;
  :deep(.el-form-item.last-form-item) {
    margin-right: 0;
  }
}
</style>